import { KYMW9200Component } from './kymw9200.component';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * 企画回管理画面の値を管理するクラス
 *
 * @export KYMW9200Model
 * @class KYMW9200Model
 */
export class KYMW9200Model {

  KYMW9200Component: KYMW9200Component;

  /** 企画回情報一覧 */
  public catalogInfoList: Array<any> = new Array<any>();

  /** 受注コードFrom */
  public orderCodeFrom: string = <string>'';

  /** 受注コードTo */
  public orderCodeTo: string = <string>'';

  /** 活性非活性判定用変数 */
  public disabledCatalogCalendarToFlg: boolean = <boolean> false;

  /**
   * 企画回情報一覧取得
   * @param serverData ユーザーリストのサーバ取得データ
   */
  public getCatalog(serverData: any) {
    if (PlessViewUtilsSub.isEmpty(serverData.Catalog) || PlessViewUtilsSub.isEmpty(serverData.Catalog.List)) {
      this.clean();
      return;
    } else {
      this.catalogInfoList = serverData.Catalog.List;
    }
  }

  public clean() {
    this.catalogInfoList = new Array<any>();
  }

}
